<div
  class="inputcontainer {{ container_class }} position-relative"
  [ngClass]="{ 'mb-3': !inline && (errorOverride || error) }"
>
<!--  *ecertDisplay="action_identifier; id: id; iconY: '15px'"-->

  <label *ngIf="!hideLabel" [ngClass]="{ error: errorOverride || error, 'mt-0': !hasMargin() }">
    {{ action_identifier | promptvalue | async }}
    <span [class.visible]="verplicht" [class.hidden]="!verplicht" style="color: #ff0000">*</span>
  </label>
  <br *ngIf="!hideLabel" />

  <ng-container *ngIf="ref_object && property">
    <ng-container *ngIf="disabled && inline; then gebruikTekst; else gebruikInput"></ng-container>
    <ng-template #gebruikTekst>
      {{ getWaarde() }}
    </ng-template>
    <ng-template #gebruikInput>
      <div>
        <input
          id="{{ id }}-inputfield"
          [attr.autocomplete]="autocomplete !== '' ? autocomplete : null"
          [(ngModel)]="ref_object[property]"
          placeholder="{{ placeholder }}"
          class="ecertnl_input input"
          [ngClass]="{ error: errorOverride || error, withoutborder: withoutborder }"
          [class.wijzigbaar]="wijzigbaar"
          [disabled]="disabled"
          [type]="type"
          [step]="1"
          (blur)="onBlur($event)"
          [maxlength]="maxlength != null ? maxlength : (action_identifier | lengthValue | async)"
          [pattern]="pattern"
          [title]="tooltip"
          (change)="onBlur($event)"
        />
        <div class="inputClearButtonWrapper" [class.hidden]="ref_object[property] == ''" *ngIf="clear_button">
          <button mat-button matSuffix mat-icon-button aria-label="Clear" type="button" (click)="reset()">
            <img src="assets/icons/ui-clear.svg" alt="kruisje" />
          </button>
        </div>
        <div class="inputEyeButtonWrapper" [class.hidden]="ref_object[property] == ''" *ngIf="show_eye && type == 'password'">
          <button mat-button matSuffix mat-icon-button aria-label="Clear" type="button" (click)="toggleType()">
            <img src="assets/icons/ui-eye.svg" alt="oogje" />
          </button>
        </div>
        <div class="inputEyeButtonWrapper" [class.hidden]="ref_object[property] == ''" *ngIf="show_eye && type == 'text'">
          <button mat-button matSuffix mat-icon-button aria-label="Clear" type="button" (click)="toggleType()">
            <img src="assets/icons/ui-eye-close.svg" alt="oogje-dicht" />
          </button>
        </div>
        <div *ngIf="celcius" class="input-wrapper celciusSuffix"></div>
      </div>
    </ng-template>
  </ng-container>

  <div class="" *ngIf="(errorOverride || error) && foutmelding != null">
    <ecert-icon class="mr-2 foutmelding" [name]="'ui-alert'" [canHover]="false" width="20px"></ecert-icon>
    <span class="font-italic pt-2">{{ foutmelding | promptvalue | async }}</span>
    <span *ngIf="foutmeldingRegel2 != null" class="font-italic pt-2"><br />{{ foutmeldingRegel2 | promptvalue | async }}</span>
    <span *ngIf="foutmeldingRegel3 != null" class="font-italic pt-3"><br />{{ foutmeldingRegel3 | promptvalue | async }}</span>
  </div>
</div>
